import React, { useEffect } from "react";
import { useParams, Outlet, Navigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from "../i18n/i18n";

const LocaleLayout = () => {
  const { lng } = useParams();
  const { i18n } = useTranslation();
  const location = useLocation();

  const isValidLang = SUPPORTED_LANGUAGES.includes(lng);

  useEffect(() => {
    if (isValidLang && i18n.language !== lng) {
      i18n.changeLanguage(lng);
    }
  }, [lng, isValidLang, i18n]);

  if (!isValidLang) {
    const currentLang = SUPPORTED_LANGUAGES.includes(i18n.language) ? i18n.language : DEFAULT_LANGUAGE;
    const segments = location.pathname.split("/").filter(Boolean);
    if (segments.length > 0) {
      segments[0] = currentLang;
    } else {
      segments.push(currentLang);
    }
    return <Navigate to={`/${segments.join("/")}${location.search}${location.hash}`} replace />;
  }

  return <Outlet />;
};

export default LocaleLayout;
